import Vue from 'vue'
import Router from 'vue-router'
import Chat from '@/sections/chat/ChatWindow'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Chat,
      name: 'Chat'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js